import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import "./index.css";

function homeServices(props) {
  return (
    <div className="serviceContainer">
      <h2>Your Mortgage Payment Support Services</h2>
      <Row
        style={{ marginLeft: "0px", marginRight: "0px" }}
        className="desktopRow"
      >
        <Col lg={3} xl={3} sm={6} md={6} xs={12}>
          <Card
            className="servicesCard"
            onClick={() =>
              (window.location = `${process.env.REACT_APP_SWMC_LINK}myloaninfo/login`)
            }
          >
            <div className="servicesCardImageDiv">
              <img
                src="https://resources.swmc.com/swmc-images/HomeImages/noun_loan_1917305.svg"
                alt="Group Icon"
              />
            </div>
            <h3>My Loan Info</h3>

            <p>Click here to make payments/ View your account details</p>
            <p className="servicearrow">
              <img
                src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                alt="Group Icon"
              />
            </p>
          </Card>
        </Col>
        <Col lg={3} xl={3} sm={6} md={6} xs={12}>
          <Link
            to="/covid19-relief"
            style={{ textDecoration: "none", color: "#000" }}
          >
            <Card className="servicesCard">
              <div className="servicesCardImageDiv">
                <img
                  src="https://resources.swmc.com/swmc-images/HomeImages/Group11579.svg"
                  alt="Group Icon"
                />
              </div>

              <h3>COVID-19</h3>

              <p>Click here to learn more about Mortgage Relief options</p>
              <p className="servicearrow">
                <img
                  src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                  alt="Group Icon"
                />
              </p>
            </Card>
          </Link>
        </Col>
        <Col lg={3} xl={3} sm={6} md={6} xs={12}>
          <Link
            style={{ textDecoration: "none", color: "#000" }}
            to="/loss-mitigation"
          >
            <Card className="servicesCard">
              <div className="servicesCardImageDiv">
                <img
                  src="https://resources.swmc.com/swmc-images/HomeImages/noun_website_2029853.svg"
                  alt="Group Icon"
                />
              </div>
              <h3>Servicing Portal</h3>
              <p>Click here to upload/download Servicing Documents</p>
              <p className="servicearrow">
                <img
                  src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                  alt="Group Icon"
                />
              </p>
            </Card>
          </Link>
        </Col>
      </Row>

      <div className="mobileDiv">
        <Row
          style={{ marginLeft: "0px", marginRight: "0px" }}
          className="mobileCardRow"
        >
          <Col lg={3} xl={3} sm={6} md={6} xs={12}>
            <Card
              className="servicesCard"
              onClick={() =>
                (window.location = `${process.env.REACT_APP_SWMC_LINK}myloaninfo/login`)
              }
            >
              <div style={{ display: "flex" }}>
                <h3 style={{ flex: "85%" }}>My Loan Info</h3>
                <div className="servicesCardImageDiv" style={{ flex: "10%" }}>
                  <img
                    src="https://resources.swmc.com/swmc-images/HomeImages/noun_loan_1917305.svg"
                    alt="Group Icon"
                  />
                </div>
              </div>
              <p>Click here to make payments/ View your account details</p>
              <p className="servicearrow">
                <img
                  src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                  alt="Group Icon"
                />
              </p>
            </Card>
          </Col>
          <Col lg={3} xl={3} sm={6} md={6} xs={12}>
            <Link
              to="/covid19-relief"
              style={{ textDecoration: "none", color: "#000" }}
            >
              <Card className="servicesCard">
                <div style={{ display: "flex" }}>
                  <h3 style={{ flex: "85%" }}>COVID-19</h3>
                  <div className="servicesCardImageDiv" style={{ flex: "10%" }}>
                    <img
                      src="https://resources.swmc.com/swmc-images/HomeImages/Group11579.svg"
                      alt="Group Icon"
                    />
                  </div>
                </div>

                <p>Click here to learn more about Mortgage Relief options</p>
                <p className="servicearrow">
                  <img
                    src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                    alt="Group Icon"
                  />
                </p>
              </Card>
            </Link>
          </Col>
          <Col lg={3} xl={3} sm={6} md={6} xs={12}>
            <Link
              style={{ textDecoration: "none", color: "#000" }}
              to="/loss-mitigation"
            >
              <Card className="servicesCard">
                <div style={{ display: "flex" }}>
                  <h3 style={{ flex: "85%" }}>Servicing Portal</h3>
                  <div className="servicesCardImageDiv" style={{ flex: "10%" }}>
                    <img
                      src="https://resources.swmc.com/swmc-images/HomeImages/noun_website_2029853.svg"
                      alt="Group Icon"
                    />
                  </div>
                </div>

                <p>Click here to upload/download Servicing Documents</p>
                <p className="servicearrow">
                  <img
                    src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                    alt="Group Icon"
                  />
                </p>
              </Card>
            </Link>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default homeServices;
